import axios from '../axios';
import {
  ADD_MERCHANT_DOCUMENT,
  UPLOAD_MERCHANT_DOCUMENT_CLOUDINARY,
  UPDATE_MERCHANT_DOCUMENT,
  GET_MERCHANT_DOCUMENT,
} from '../ApiUrl';

// Hedaer is added just for testing to capture header getting with this API,we can also pass header with mob header extention
export const onAddMerchantDocAPI = async (payload) => {
  try {
    const response = await axios.post(ADD_MERCHANT_DOCUMENT, payload, {
      headers: {
        syed: 'syed',
      },
    });
    return response;
  } catch (error) {
    console.log('onAddMerchantDocAPI catch block', error);
    return { success: false, error };
  }
};

export const onGetMerchantDocAPI = async (payload) => {
  try {
    const response = await axios.post(GET_MERCHANT_DOCUMENT, payload);
    return response;
  } catch (error) {
    console.log('onGetMerchantDocAPI catch block', error);
    return { success: false, error };
  }
};

export const onUpdateMerchantDocAPI = async (payload) => {
  try {
    const response = await axios.put(UPDATE_MERCHANT_DOCUMENT, payload);
    return response;
  } catch (error) {
    console.log('onUpdateMerchantDocAPI catch block', error);
    return { success: false, error };
  }
};

export const onUploadMerchantDocCloudinaryAPI = async (formData) => {
  try {
    const response = await axios.post(UPLOAD_MERCHANT_DOCUMENT_CLOUDINARY, formData, {
      // ✅ Let axios set the boundary automatically
      headers: { 'Content-Type': 'multipart/form-data' },
    });

    return response;
  } catch (error) {
    console.log('onUploadMerchantDocCloudinaryAPI catch block', error);
    return { success: false, error };
  }
};
